import React, { type PropsWithChildren, type ReactNode } from 'react';
import { Text, Inline, xcss, Box } from '@atlaskit/primitives';
import WithProfileCard from '@atlassian/jira-issue-view-internal-profilecard-next/src/index.tsx';
import type { User } from '@atlassian/jira-issue-shared-types/src/common/types/user-type.tsx';

type Props = {
	user?: User;
	authorInfo?: ReactNode;
	authorActivity?: ReactNode;
};
const Author = ({ user, authorInfo, authorActivity }: PropsWithChildren<Props>) => {
	return (
		<Inline space="space.050" alignBlock="center" grow="fill" xcss={authorStyles}>
			<Box xcss={userNameStyles}>
				<WithProfileCard
					userAccount={user}
					analyticsData={{ trigger: 'comment-author' }}
					shouldTruncate
				>
					<Text weight="bold">{user?.displayName}</Text>
				</WithProfileCard>
			</Box>
			{!!authorInfo && <Box xcss={additionalContentStyles}>{authorInfo}</Box>}
			{!!authorActivity && <Box xcss={additionalContentStyles}>{authorActivity}</Box>}
		</Inline>
	);
};

export default Author;

const authorStyles = xcss({
	gridArea: 'header-author',
	overflow: 'hidden',
});
const userNameStyles = xcss({
	minWidth: '0px',
});
const additionalContentStyles = xcss({
	flexShrink: 0,
});
